import { makeStyles, Theme, createStyles } from "@material-ui/core";

export const useApplicantStyles = makeStyles((theme: Theme) =>
    createStyles({
        applicantContainer: {
            maxHeight: "200px",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
                width: "6px"
            },
            "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
                borderRadius: "3px"
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#c1c1c1",
                borderRadius: "3px",
                "&:hover": {
                    background: "#a8a8a8"
                }
            }
        },
        applicantCard: {
            padding: theme.spacing(1.5),
            marginBottom: theme.spacing(1),
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: theme.shape.borderRadius,
            transition: "all 0.2s ease-in-out",
            "&:hover": {
                transform: "translateY(-1px)"
            },
            "&:last-child": {
                marginBottom: 0
            }
        },
        applicantInfo: {
            flex: 1,
            minWidth: 0
        },
        applicantName: {
            fontWeight: 500,
            marginBottom: theme.spacing(0.5),
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        applicantEmail: {
            display: "block",
            marginBottom: theme.spacing(0.5),
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        applicantId: {
            fontSize: "0.6875rem",
            height: "20px",
            fontFamily: "monospace"
        },
        actionContainer: {
            marginLeft: theme.spacing(1.5),
            flexShrink: 0
        }
    })
);
